// * Import required libraies
import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

// * Import Custom Component
import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";
// import Sidenav from "../../components/Sidenav/Sidenav";
import Loader from "../../components/Loader/Loader";
import SigviewTypography from "../../components/Common/SigviewTypography";
import SidenavDrawer from "../../components/SidenavDrawer/SidenavDrawer";

const PageTitle = (props) => {
  const { title = "Sample Page Title", variant = "pLarger", children } = props;
  return (
    <article className="main-content-page-title">
      <SigviewTypography variant={variant}>{title}</SigviewTypography>
      {children}
    </article>
  );
};

function LayoutTopSideBottom(props = {}) {
  const {
    user = {},
    children = <></>,
    sidenavProps = {},
    workbooks = {},
    eventHandlers = {},
    activeWorkspace = {},
  } = props;
  const [open, setOpen] = useState(false);
  const handleDrawer = () => {
    setOpen((prev) => !prev);
  };

  return (
    <>
      {user.screen.isDashboardLoading && (
        <section className={`dashboard-loader-container`}>
          <Loader />
        </section>
      )}
      <div className={`page layout-top-side-bottom`}>
        <main
          style={{
            "--sidenav-width": open ? "240px" : "65px",
          }}
        >
          <section className={`sidenav`}>
            {/* <Sidenav {...sidenavProps} /> */}
            <SidenavDrawer
              {...sidenavProps}
              open={open}
              handleDrawer={handleDrawer}
            />
          </section>
          <section className={`content`}>
            <Header
              workbooks={workbooks}
              eventHandlers={eventHandlers}
              activeWorkspace={activeWorkspace}
            />
            <section className={`main-content-data`}>{children}</section>
            <Footer />
          </section>
        </main>
      </div>
    </>
  );
}

LayoutTopSideBottom.propTypes = {
  children: PropTypes.node,
  user: PropTypes.object,
};

const mapStateToProps = (state) => ({ user: state.user });

export { PageTitle };

export default connect(mapStateToProps)(LayoutTopSideBottom);
